import React from 'react';

const ToolTipButton = ({ text, onClick }) => {
	return <button onClick={onClick}>{text}</button>;
};

export default ToolTipButton;
